import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { PillGroup } from './PillGroup.js';
import { RemovablePill } from './RemovablePill.js';
import { Pill } from './Pill.js';
import '@elliemae/ds-classnames';
import '@elliemae/ds-shared/FocusGroup/FocusGroupManager';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-icons/CloseXsmall';
import '@elliemae/ds-shared/FocusGroup/useFocusGroupItem';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/defineProperty';

function LabeledPills(_ref) {
  var children = _ref.children,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      leftAddon = _ref.leftAddon,
      onFocusGroupSet = _ref.onFocusGroupSet,
      onFocusNextGroup = _ref.onFocusNextGroup,
      onFocusPreviousGroup = _ref.onFocusPreviousGroup;
  return /*#__PURE__*/React.createElement(PillGroup, {
    onFocusGroupSet: onFocusGroupSet,
    onFocusNextGroup: onFocusNextGroup,
    onFocusPreviousGroup: onFocusPreviousGroup
  }, /*#__PURE__*/React.createElement(Pill, {
    label: label,
    leftAddon: leftAddon,
    variant: "title",
    "data-testid": "pill-title"
  }), children);
}

var props = {
  /** labeled pill text label */
  label: PropTypes.string.isRequired.description('pill text label'),

  /** pill to add the label to */
  children: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf([PropTypes.instanceOf(Pill), PropTypes.instanceOf(RemovablePill)])
  })).isRequired.description('pill to add the label to'),

  /** addon component to left */
  leftAddon: PropTypes.node.description('addon component to left'),

  /** focus next group callback */
  onFocusNextGroup: PropTypes.func.description('focus next group callback'),

  /** focus prev group callback */
  onFocusPreviousGroup: PropTypes.func.description('focus prev group callback'),

  /** focus group set callback */
  onFocusGroupSet: PropTypes.func.description('focus group set callback')
};
LabeledPills.propTypes = props;
var DSLabeledPillsWithSchema = describe(LabeledPills);
DSLabeledPillsWithSchema.propTypes = props;

export { DSLabeledPillsWithSchema, LabeledPills };
//# sourceMappingURL=LabeledPills.js.map
